<template>
    <div class="modal-card card">
        <form @submit.prevent="onAddJobStackJob()">
            <div class="card-header">
                <!-- Title -->
                <h4 class="card-header-title">
                    Add Template Job to {{modalData.name}} Stack
                </h4>
                <!-- Close -->
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="card-body overflow-visible">
                <InputField label="Template Job Name" type="multiselect" v-model="template" 
                    :editable="true" :createOption="false"
                    :options="templateJobOptions" :validate="[{ type: 'required', errMsg: 'select template job' }]" />

            </div>
            <div class="card-footer">
                <div class="text-end">
                    <button class="btn btn-primary" :disabled="btnDisable" type="submit">Add</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import InputField from "../InputField.vue";
import { mapState } from "vuex";
export default {
    components: { InputField },
    name: "AddJobStackJob",
    data() {
        return {
            template:this.modalData?.list || [],
            templateJobOptions: []
        }
    },
    props: {
        modalData: {
            type: [Object, Array, String],
        },
    },
    computed: {
        ...mapState({
            templateJobs: (state) => state.amdp.templateJobs
        }),
        jobStack() {
            return this.modalData.jobStack ? this.modalData.jobStack : {}
        },
        btnDisable(){
            return !(this.template)
        }
    },
    watch:{
         templateJobs: {
            handler(newVal) {
                this.templateJobOptions = newVal.map((job) => {
                    return job.name
                })
            },
            deep: true,
            immediate: true
        }
    },
    beforeMount() {
        if (!this.templateJobs.length) {
            this.$store.dispatch("amdp/fetchTemplateJobs");
        }
        this.templateJobOptionslist = this.templateJobs.map((job) => {
                return job.name
        })
    },
    methods: {
        async onAddJobStackJob() {
            if(this.template.length>0){
                let list = this.template.map(job => {
                    let found = this.templateJobs.find(item => item.name === job);
                    return found;
                });
                this.$store.dispatch('hideModal')
                this.modalData.onSaveChange(list);
            }else {
                let toastoptions = {
                    message: "Already template job exits in job stacks.'",
                    type: "error",
                };
                this.$store.dispatch('addToast', toastoptions);
            }
        }
    }
};
</script>

<style></style>